export default "__VITE_ASSET__JZ1DsncR__"